package com.milta.feature.route.domain.entity

/**
 * One row of the web dashboard's "Historique des tournées" list (MIL-52, Screen A —
 * `GET /api/v1/routes/history`). Distinct from [DriverRouteOverview] (today/tomorrow team
 * dashboard, MIL-48): this one is a flat per-route history record spanning several days, with its
 * own [deliveredCount]/[failedCount] split rather than a single progress ratio.
 */
data class RouteHistoryItem(
    val routeId: String,
    /** `yyyy-MM-dd`. */
    val date: String,
    val driverId: String,
    val driverFirstName: String,
    val driverLastName: String,
    val totalDeliveries: Int,
    val deliveredCount: Int,
    val failedCount: Int,
)
